/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {AfterViewInit, Component, ViewEncapsulation} from '@angular/core';
import {Helpers} from '../helpers';

@Component({
  selector: '.page-wrapper',
  templateUrl: './layout.component.html',
  encapsulation: ViewEncapsulation.None
})

export class LayoutComponent implements AfterViewInit {

  constructor() {
    // This is intentional
  }

  ngAfterViewInit() {
    Helpers.initLayout();
  }
}
